import { Button } from '@/ui-kit'
import { ArrowLeft, Check } from 'lucide-react'

const formatDuration = (totalSec: number) => {
  const min = Math.floor(totalSec / 60)
  const sec = totalSec % 60
  if (min === 0) return `${sec}s`
  return `${min}m ${sec}s`
}

export const ConversationCompleteStep = ({ phase, onBack }: { phase: { durationSec: number }; onBack: () => void }) => {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex flex-col items-center gap-6 text-center">
        <div className="flex size-20 items-center justify-center rounded-full bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400">
          <Check className="size-9" />
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="text-lg font-semibold">Conversation Complete</h2>
          {phase.durationSec > 0 && (
            <p className="text-muted-foreground text-sm">Duration: {formatDuration(phase.durationSec)}</p>
          )}
        </div>
        <Button variant="bordered" onClick={onBack}>
          <ArrowLeft className="size-4" />
          Pick Another Project
        </Button>
      </div>
    </div>
  )
}
